const createWallet = (wallet) => {
    var _a;
    return ({
        isInstalledOnBrowser: (_a = wallet.isInstalledOnBrowser()) !== null && _a !== void 0 ? _a : false,
        key: wallet.key,
        name: wallet.name,
        walletConnector: wallet,
    });
};

export { createWallet };
